<template>
  <div>
    <Search v-if="currentApi === 'Search'" :map="map" />
    <RevGeocode v-if="currentApi === 'Reverse Geocode'" :map="map" />
    <DataImport v-if="currentApi === 'Import'" :map="map" />
  </div>
</template>

<style></style>

<script>
import Search from '@/components/Search';
import RevGeocode from '@/components/RevGeocode';
import DataImport from '@/components/DataImport';

export default {
  name: 'SidePanel',
  props: ['currentApi', 'map'],
  methods: {},
  data() {
    return {};
  },
  components: {
    Search,
    RevGeocode,
    DataImport
  }
};
</script>
